// Models
// Utilities
import { generateGuid } from "@ms/uno-utilities/lib/local/Guid";
/**
 * Dynamic filter.
 */ export class DynamicFilter {
    /**
     * Return a new filter with the editable property updated, stamped with the current modification time.
     */ setProperty(key, value) {
        return new DynamicFilter({
            id: this.id,
            scope: {
                type: this.scope.type,
                id: this.scope.id
            },
            title: this.title,
            description: this.description,
            createdAt: this.createdAt,
            modifiedAt: Date.now(),
            [key]: value
        });
    }
    /**
     * Convert the filter to a persisted resource.
     */ forSerialization() {
        return {
            id: this.id,
            scope: {
                type: this.scope.type,
                id: this.scope.id
            },
            title: this.title,
            description: this.description,
            createdAt: this.createdAt,
            modifiedAt: this.modifiedAt
        };
    }
    /**
     * Reconstruct a dynamic filter from a persisted resource.
     */ static fromPersistedResource(resource) {
        return new DynamicFilter({
            id: resource.id,
            scope: {
                type: resource.scope.type,
                id: resource.scope.id
            },
            title: resource.title,
            description: resource.description,
            createdAt: resource.createdAt,
            modifiedAt: resource.modifiedAt
        });
    }
    constructor(properties){
        this.id = properties.id ?? generateGuid();
        this.scope = properties.scope;
        this.title = properties.title;
        this.description = properties.description;
        this.createdAt = properties.createdAt ?? Date.now();
        this.modifiedAt = properties.modifiedAt ?? this.createdAt;
    }
}
